import { Button, styled } from '@mui/material';

export const StyledButton = styled(Button)(() => ({
  backgroundColor: '#E7F4FF',
  border: 'solid 1.5px #5D8BB2',
  width: '100%',
  height: '56px',
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: '#E7F4FF',
    border: 'solid 1.5px #5D8BB2',
  },
}));
